var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 42,
    viewBox: "0 0 60 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M49.2728 0.779297H10.0431C7.38132 0.779297 4.82914 1.83366 2.94679 3.71033C1.06443 5.58642 0.0078125 8.13163 0.0078125 10.785V31.707C0.0078125 34.3602 1.0646 36.9056 2.94679 38.7824C4.82914 40.6585 7.38114 41.7127 10.0431 41.7127H49.2728C51.9346 41.7127 54.4875 40.6583 56.3691 38.7824C58.2514 36.9056 59.3088 34.3604 59.3088 31.707V10.785C59.3088 8.13181 58.2513 5.58642 56.3691 3.71033C54.4875 1.83352 51.9347 0.779297 49.2728 0.779297ZM32.1668 25.7944L23.2719 30.3426V12.1505L41.0618 21.2471L32.1668 25.7944Z",
    fill: "#FAFAFA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.07b858d5207136edf9f331d3cdd52f11.svg";
export { ForwardRef as ReactComponent };